import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

export function ProtectedRoute({ children, allowedRoles = ['student'] }) {
  const { currentUser, currentInstructor, isAdmin } = useAuth();

  if (allowedRoles.includes('admin') && isAdmin) {
    return children;
  }

  if (allowedRoles.includes('instructor') && currentInstructor) {
    return children;
  }

  if (allowedRoles.includes('student') && currentUser) {
    if (allowedRoles.includes('approved') && !currentUser.approved) {
      return <Navigate to="/pending" replace />;
    }
    return children;
  }

  return <Navigate to="/" replace />;
}

export function PublicRoute({ children }) {
  const { currentUser, currentInstructor, isAdmin } = useAuth();

  if (isAdmin) return <Navigate to="/admin" replace />;
  if (currentInstructor) return <Navigate to="/instructor" replace />;
  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
